import React from 'react'

export function SmallContainer(props: { children: React.ReactNode }) {
  return (
    <div className="container" style={{ maxWidth: '700px' }}>
      {props.children}
    </div>
  )
}
